export default function authHeader(contentType, newHeaders = {}) {
  const authData = JSON.parse(localStorage.getItem("authData"));

  // Default headers
  const headers = {
    "Content-Type": contentType || "application/json", // Default to JSON if no contentType provided
  };

  // Add Authorization header if access_token exists
  if (authData && authData.access_token) {
    headers.Authorization = "Bearer " + authData.access_token;
  }

  // Merge with new headers
  return { ...headers, ...newHeaders };
}
